import Form from "./forms/form";
import About from "./about";
import { TypeAnimation } from "react-type-animation";

export default function Banner({ toggleModal, id }) {
  return (
    <section
      id={id}
      className="relative block w-full pt-32 pb-10"
      style={{
        background: "url(https://glocify.com/images/banner-hero-img.png)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover"
      }}
    >
      <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">
        <div className="lg:flex lg:grid-cols-2 gap-4 lg:gap-y-0 gap-y-6">
          <div className="lg:w-[63%]">
            <div
              className="flex items-center gap-3 mb-6 xl:justify-start sm:justify-start justify-center"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <img src="https://glocify.com/images/android.svg" alt="android" />
              <img
                src="https://glocify.com/images/line-white.svg"
                alt="line-white"
              />
              <img src="https://glocify.com/images/apple.svg" alt="apple" />
            </div>
            <h1
              data-aos="fade-up"
              data-aos-duration="1500"
              className="lg:text-[64px] text-[35px] font-bold text-white lg:leading-[76px] leading-normal mb-3 lg:text-left sm:text-left text-center"
            >
              We build  Amazing <br />
              <TypeAnimation
                sequence={[
                  "Mobile Apps",
                  1000,
                  "Cross Platform App",
                  1000,
                  "AI Powered App",
                  1000,
                  "Point of Sale App",
                  1000
                ]}
                wrapper="span"
                speed={50}
                className="bg-[linear-gradient(269.02deg,#FF37EB_25.44%,#9A4AFF_64%)] bg-clip-text text-transparent"
                repeat={Infinity}
              />
              <br />
              In just{" "}
              <span className="bg-[linear-gradient(269.02deg,#FF37EB_25.44%,#9A4AFF_64%)] bg-clip-text text-transparent">
                60 Days
              </span>
            </h1>
            <p
              className="text-xl font-normal leading-8 text-white mb-8 lg:text-left sm:text-left text-center"
              data-aos="fade-up"
              data-aos-duration="2500"
            >
              Bring your app to life with speed and perfection —
              <br className="lg:block hidden"/> your vision, our expertise. 
            </p>
           
            <button
              className="relative flex xl:w-auto lg:w-auto sm:w-auto w-full h-[52px] py-3 px-10 items-center justify-center gap-2 overflow-hidden bg-transparent border border-solid border-white hover:border-[#7C46EF] rounded-[10px] text-white shadow-2xl text-base font-medium uppercase transition-all duration-700 ease-out before:absolute before:h-0 before:w-0 before:rounded-[10px] before:bg-[linear-gradient(269.02deg,#FF37EB_10.44%,#7c46ef_60%)] before:duration-700 before:ease-out hover:shadow-[#7c46ef]/20 hover:before:h-56 hover:before:w-full"
              onClick={toggleModal}
              data-aos="fade-up"
              data-aos-duration="2800"
            >
              <span className="relative z-10">Talk to an Expert</span>
              {/* <svg
                className="w-4 h-4 text-white z-10"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg> */}
            </button>
          </div>
          {/* <div className="lg:w-[36%]">
            <div
              id="bannerForm"
              className="bg-white p-6  rounded-[32px] bannerForm"
              data-aos="fade-left"
              data-aos-duration="2500"
            >
              <h3 className="text-[22px] font-bold leading-[33px] tracking-tight text-black mb-6">
                Start Building Your App With Us!
              </h3>
              <Form contactformid="19144" />
            </div>
          </div> */}
        </div>
      </div>
      {/* <div className="border-t border-solid border-white/20 mt-16 pt-8 pb-[38px]">
        <div className="container mx-auto">
          <About />
        </div>
      </div> */}
    </section>
  );
}
